import { LinkOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import PageModalNavigation from "@/components/Elements/PageModalNavigation";
import ObservationModalContent from "@/components/Observation/ObservationModalContent";
import { getObservationTitle, useGetObservation } from "@/entities/observation";
import ModelFavoriteButton from "@/modules/model-favorite-button";
import { ModelLink } from "@/modules/model-link";
import ObservationBreadcrumb from "@/modules/observation/observation-breadcrumb";
import { PageItemContextGate } from "@/modules/page-item-context-gate";
import PageModal from "@/modules/page-modal";
import { StateEditForm } from "@/modules/state-edit-form";
import { useIdParam } from "@/services/router";

export const ObservationPage = () => {
  const id = useIdParam();
  const { t } = useTranslation();

  const { observation, context, error, isLoading } = useGetObservation(id);
  const sourceIntervention = observation?.source_intervention;

  return (
    <PageItemContextGate
      model="observation"
      itemContext={context}
      queryError={error}
      isModalPage
      modalPageLoading={isLoading}
    >
      <PageModal
        keyboard
        mask={{ closable: true }}
        title={getObservationTitle(observation)}
        beforeTitle={
          <PageModalNavigation
            model="observation"
            itemId={id}
            formatTitle={getObservationTitle}
          />
        }
        afterTitle={
          sourceIntervention && (
            <Tooltip title={t("observation:sourceObservationLink")}>
              <ModelLink
                model="intervention"
                item={sourceIntervention}
                search={`?observation_id=${id}`}
                aria-label={t("observation:sourceObservationLink")}
              >
                <LinkOutlined />
              </ModelLink>
            </Tooltip>
          )
        }
        loading={isLoading}
        className="observation-modal"
        breadcrumb={
          observation && <ObservationBreadcrumb observation={observation} />
        }
        headerActions={
          observation && [
            <StateEditForm
              key="state-edit"
              stateType="observation"
              model={observation}
            />,
            <ModelFavoriteButton
              key="favorite"
              loading={isLoading}
              modelKey="observation"
              item={observation}
              style={{ height: 32 }}
            />,
          ]
        }
      >
        {observation && <ObservationModalContent observation={observation} />}
      </PageModal>
    </PageItemContextGate>
  );
};
